export default {
  filters: {
    managers: {
      placeholder: 'Gestores de vendas',
    },
  },
  metrics: {
    collected_commission: 'Comissão total',
  },
  fields: {
    manager: 'Gestor',
    area: 'Localização',
    total_amount: 'Ganhos',
    companies_live: 'Ativo',
    restaurant: 'Restaurante',
    live_from: 'Ativo desde',
    plan_amount: 'Valor do plano',
    prepayment_bonus_amount: 'Bónus de pré-pagamento',
    lead_source_bonus_amount: 'Bónus de fonte de lead',
    google_business_bonus_amount: 'Bónus de ligação Google Business',
    promo_code_bonus_amount: 'Bónus de código promocional mestre',
    smart_pricing_bonus_amount: 'Bónus de preço inteligente',
    mobile_app_bonus_amount: 'Bónus de aplicação móvel',
    sales_goal_bonus_amount: 'Bónus de objetivo de vendas',
  },
  buttons: {
    export: 'Exportar',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
  },
};
